import type { ChartSettingsT } from 'business/definitions';
import { initialSettingsState } from 'modules/decision/pages/Explore/hooks/reducers/settingsReducer';
import type {
    OnQuerySucceededPayload,
    SettingsState,
    VizSettingsPayload,
} from 'modules/decision/pages/Explore/hooks/reducers/types';
import { createContext, useContext } from 'react';

type SettingsDispatchContextT = {
    resetSettings: () => void;
    applyChartSettings: (chartSettings: ChartSettingsT) => void;
    replaceChartSettings: (chartSettings: ChartSettingsT) => void;
    updateVizSettings: (vizSettings: VizSettingsPayload) => void;
    onQuerySucceeded: (payload: OnQuerySucceededPayload) => void;
    setReloadChart: (value: boolean) => void;
};

export const SettingsContext =
    createContext<SettingsState>(initialSettingsState);

export const SettingsDispatchContext = createContext<SettingsDispatchContextT>({
    resetSettings: () => {},
    applyChartSettings: () => {},
    replaceChartSettings: () => {},
    updateVizSettings: () => {},
    onQuerySucceeded: () => {},
    setReloadChart: () => {},
});

export const useSettingsContext = () => useContext(SettingsContext);
export const useSettingsDispatchContext = () =>
    useContext(SettingsDispatchContext);
